/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { BidBiddersControllerRemoveMutationResponse, BidBiddersControllerRemovePathParams, BidBiddersControllerRemove401, BidBiddersControllerRemove403, BidBiddersControllerRemove404 } from "../../models/bidsController/BidBiddersControllerRemove";

function getBidBiddersControllerRemoveUrl(id: BidBiddersControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/bidders/${id}` as const }  
  return res
}

/**
 * @description Soft-deletes them with their questions and supersedes their pending suggestions. Deleting the winner clears the award.
 * @summary Delete a trade partner
 * {@link /api/v1/bidders/:id}
 */
export async function bidBiddersControllerRemove(id: BidBiddersControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<BidBiddersControllerRemoveMutationResponse, ResponseErrorConfig<BidBiddersControllerRemove401 | BidBiddersControllerRemove403 | BidBiddersControllerRemove404>, unknown>({ method : "DELETE", url : getBidBiddersControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}